const ThemeObj = {
  token: {
    colorPrimary: "#04286f",
    fontFamily: "Montserrat-SemiBold",
  },
};

export default ThemeObj;
